import React from "react";
import { Link } from "react-router-dom";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import BuildIcon from "@material-ui/icons/Build";

// ─── Styles ───────────────────────────────────────────────────────────────────

const tileStyle = {
  width: "220px",
  minHeight: "280px",
  padding: "24px",
  boxSizing: "border-box",
  boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: "0 0 auto",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  whiteSpace: "normal",
  overflow: "hidden",
  borderRadius: "4px",
  textAlign: "center",
};

const comingSoonTileStyle = {
  ...tileStyle,
  opacity: 0.45,
};

// ─── Tile data ────────────────────────────────────────────────────────────────

const TILES = [
  {
    label: "Existing Group Management",
    description: "Manage existing group plans.",
    to: "/GroupLogin",
    icon: <ContactMailIcon style={{ fontSize: 64, color: "#0056a3", marginBottom: 8 }} />,
    active: true,
  },
  {
    label: "New Group Implementation",
    description: "Add a new group plan.",
    to: "/GroupImplementation",
    icon: <BuildIcon style={{ fontSize: 64, color: "#666", marginBottom: 8 }} />,
    active: true,
  },
  // {
  //   label: "Renew Group",
  //   description: "Coming soon. This feature is not yet available.",
  //   icon: <BuildIcon style={{ fontSize: 64, color: "#666", marginBottom: 8 }} />,
  //   active: false,
  // },
  // {
  //   label: "Terminate Group",
  //   description: "Coming soon. This feature is not yet available.",
  //   icon: <BuildIcon style={{ fontSize: 64, color: "#666", marginBottom: 8 }} />,
  //   active: false,
  // },
];

// ─── Component ────────────────────────────────────────────────────────────────

const GroupPlanManagement = () => (
  <div
    role="main"
    className="main-container pt-md-5 pb-5 container js-quickedit-main-content"
  >
    <div className="row d-md-flex">
      <section className="col-sm-12 internal-page">
        <div className="region region-content">

          {/* Breadcrumb */}
          <section className="block block-clearstone-updates block-clearstone-breadcrumbs-block clearfix">
            <div className="breadcrumb-wrap">
              <div className="region--breadcrumb nst-1">
                <section className="block-system block-system-breadcrumb-block">
                  <div role="navigation">
                    <ol className="breadcrumb">
                      <li><Link to="/">Home</Link></li>
                      <li>Group Plan Management</li>
                    </ol>
                  </div>
                </section>
              </div>
            </div>
          </section>

          <h1 className="page-header">Group Plan Management</h1>

          <div
            className="flex-container contactbox"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "100%",
              marginTop: "24px",
            }}
          >
            {TILES.map((tile, i) =>
              tile.active ? (
                <div key={i} style={tileStyle}>
                  <Link to={tile.to}>{tile.icon}</Link>
                  <h3 style={{ textAlign: "center" }}><Link to={tile.to}>{tile.label}</Link></h3>
                  <p style={{ textAlign: "center" }}>{tile.description}</p>
                </div>
              ) : (
                <div key={i} style={comingSoonTileStyle} aria-hidden="true">
                  {tile.icon}
                  <h3 style={{ color: "#666", textAlign: "center" }}>{tile.label}</h3>
                  <p style={{ textAlign: "center" }}>{tile.description}</p>
                </div>
              )
            )}
          </div>

        </div>
      </section>
    </div>
  </div>
);

export default GroupPlanManagement;
